import axios from 'axios'
import { BASE_URL } from '../AppConfig'
import IAuth from '../interfaces/Common/IAuth'

interface IRoute {
  status: string
  delivery_date: string,
  number_vehicle: number
  max_distance: number
  max_drop: number
  rest_time: number
  cond_id: number
}

interface ICond {
  number_vehicle: number
  max_distance: number
  max_drop: number
  rest_time: number
  cond_id: number
  max_item: number
  max_route_total_distance: number
  include_depot_in_total_distance: boolean
  use_route_order_optimize: boolean
  route_order_max_nodes: number
  route_order_friend_depth: number
}


export default {
  routeAutoExecute: async function (auth: IAuth, data: IRoute) {
    const response = await axios.post(`${BASE_URL}/route_auto/execute`, {
      status: data.status,
      delivery_date: data.delivery_date,
      number_vehicle: data.number_vehicle,
      max_distance: data.max_distance,
      max_drop: data.max_drop,
      rest_time: data.rest_time,
      cond_id: data.cond_id
    },
      {
        timeout: 3600000,
        headers: { action_user_id: auth?.action_user_id, token_id: auth?.token_id }
      })
    return response
  },

  routeAutoCheckModel: async function (auth: IAuth, data: IRoute) {
    const response = await axios.post(`${BASE_URL}/route_auto/check_model`, {
      status: data.status,
      delivery_date: data.delivery_date,
      number_vehicle: data.number_vehicle,
      max_distance: data.max_distance,
      max_drop: data.max_drop,
      rest_time: data.rest_time,
      cond_id: data.cond_id
    },
      {
        timeout: 1200000,
        headers: { action_user_id: auth?.action_user_id, token_id: auth?.token_id }
      })
    return response
  },

  // 2.1 สั่งคำนวณเส้นทางแบบ async -> ได้ job_id ไป poll ต่อ
  executeAsync: async function (auth: IAuth, data: IRoute) {
    const response = await axios.post(`${BASE_URL}/route_auto/execute_async`, {
      status: data.status,
      delivery_date: data.delivery_date,
      number_vehicle: data.number_vehicle,
      max_distance: data.max_distance,
      max_drop: data.max_drop,
      rest_time: data.rest_time,
      cond_id: data.cond_id
    },
      {
        params: { action_user_id: auth?.action_user_id, app_cust_id: auth?.app_cust_id },
        timeout: 1200000,
        headers: { action_user_id: auth?.action_user_id, token_id: auth?.token_id }
      })
    return response
  },

  // 2.2 - 2.5 poll สถานะการคำนวณด้วย job_id
  executeStatus: async function (auth: IAuth, job_id) {
    const response = await axios.get(`${BASE_URL}/route_auto/execute_status`, {
      params: { job_id, action_user_id: auth?.action_user_id, app_cust_id: auth?.app_cust_id },
      headers: { action_user_id: auth?.action_user_id, token_id: auth?.token_id }
    })
    return response.data
  },

  checkBuildStatus: async function (auth: IAuth, build_model_id) {
    try {
      const response = await axios.get(`${BASE_URL}/route_auto/build_model_status?build_model_id=${build_model_id}`, {
        headers: { action_user_id: auth?.action_user_id, token_id: auth?.token_id }
      })
      return response.data
    } catch (error) {
      throw error
    }
  },

  getCond: async function (auth: IAuth) {
    try {
      const response = await axios.get(`${BASE_URL}/route_auto/get_cond`, {
        headers: { action_user_id: auth?.action_user_id, token_id: auth?.token_id }
      })
      return response.data
    } catch (error) {
      throw error
    }
  },

  setCond: async function (auth: IAuth, data: ICond) {
    const response = await axios.post(`${BASE_URL}/route_auto/set_cond`, {
      number_vehicle: data.number_vehicle,
      max_distance: data.max_distance,
      max_drop: data.max_drop,
      rest_time: data.rest_time,
      cond_id: data.cond_id,
      max_item: data.max_item,
      max_route_total_distance: data.max_route_total_distance,
      include_depot_in_total_distance: data.include_depot_in_total_distance,
      use_route_order_optimize: data.use_route_order_optimize,
      route_order_max_nodes: data.route_order_max_nodes,
      route_order_friend_depth: data.route_order_friend_depth
    },
      {
        headers: { action_user_id: auth?.action_user_id, token_id: auth?.token_id }
      })
    return response
  },


  getShippoint: async function (auth: IAuth) {
    try {
      const response = await axios.get(`${BASE_URL}/route_auto/get_shippoint`, {
        headers: { action_user_id: auth?.action_user_id, token_id: auth?.token_id }
      })
      return response.data
    } catch (error) {
      throw error
    }
  },
}